var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, validationId) {
      


































pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};


















































pug_mixins["checkbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
if (!attributes.attributes) {
attributes.attributes = {}
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "checkbox schema-form-checkbox"},attributes.groupAttributes]), true)) + "\u003E\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes([attributes.fieldHtmlClass], [true]),"type": "checkbox","ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"id": pug.escape(id),"name": pug.escape(id),"required": pug.escape(attributes.required),"ng-true-value": pug.escape(attributes['ng-true-value']),"ng-false-value": pug.escape(attributes['ng-false-value']),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E";
};




















































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003C!--.cockpit-panel--\u003E\u003C!-- .cockpit-panel__title Checks--\u003E\u003C!-- .cockpit-panel__body.employee-filters-containter--\u003E\u003C!--   .row--\u003E\u003C!--     .column--\u003E\u003C!--       button.button.button-primary(--\u003E\u003C!--         overlay=\"BonusAdminCtrl.loading.check_restbonuses_for_fid\"--\u003E\u003C!--         ng-click=\"BonusAdminCtrl.check_restbonuses_for_fid(true)\"--\u003E\u003C!--       ) Check future restbonuses for FID--\u003E\u003C!--   .row--\u003E\u003C!--     .column--\u003E\u003C!--       button.button.button-primary(--\u003E\u003C!--         overlay=\"BonusAdminCtrl.loading.check_restbonuses_for_fid\"--\u003E\u003C!--         ng-click=\"BonusAdminCtrl.check_restbonuses_for_fid()\"--\u003E\u003C!--       ) Check restbonuses for FID--\u003E\u003C!--   .row--\u003E\u003C!--     .column--\u003E\u003C!--       button.button.button-primary(--\u003E\u003C!--         overlay=\"BonusAdminCtrl.loading.fix_future_data\"--\u003E\u003C!--         ng-click=\"BonusAdminCtrl.fix_future_data()\"--\u003E\u003C!--       ) Update bikes with future data--\u003E\u003C!----\u003E\u003C!--   .row(ng-if=\"BonusAdminCtrl.overspend_amount\")--\u003E\u003C!--     .columns.small-3 Overspend amount--\u003E\u003C!--     .columns.small-3 {{ BonusAdminCtrl.overspend_amount}}--\u003E\u003C!----\u003E\u003C!--   .row(ng-repeat=\"problematic_user in BonusAdminCtrl.problematic_users\")--\u003E\u003C!--     .columns.small-3 {{ problematic_user.valuenet_id }}--\u003E\u003C!--     .columns.small-3 {{ problematic_user.upcoming_restbonus}}--\u003E\u003Cdiv class=\"cockpit-panel\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003E {{BonusAdminCtrl.employees.length}} {{ BonusAdminCtrl.employees.length \u003E 0 ? \"Arbeitnehmer gefunden\" : \"\"}} {{BonusAdminCtrl.employees.length === 0 ? \"Arbeitnehmer gefunden. Bitte mindestens einen Filter angeben\" : \"\"}}\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body employee-filters-containter\"\u003E\u003Cdiv class=\"row\"\u003E\u003Ch1\u003EBonus\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "filters.id","title": "ValueNetID","data-cy": "vn.administration.bonus.employeeFilters.inputEmployeeId","attributes": {"ng-keyup":"BonusAdminCtrl.triggerSearch($event)"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "filters.custId","title": "Kunde","attributes": {"ng-keyup":"BonusAdminCtrl.triggerSearch($event)"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003EComponent Name\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"filters.component_name.selected\" theme=\"select2\" title=\"Made Status Filter\" search-enabled=\"false\" multiple close-on-select=\"false\" style=\"width:100%\"\u003E\u003Cui-select-match placeholder=\"Select component names\" allow-clear=\"true\"\u003E{{$item.title}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"component_name in filters.component_name.options track by $index\"\u003E\u003Cspan ng-bind=\"component_name.title\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "filters.name","title": "Vorname Name","attributes": {"ng-keyup":"BonusAdminCtrl.triggerSearch($event)"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "filters.personal_number","title": "Personalnummer","attributes": {"ng-keyup":"BonusAdminCtrl.triggerSearch($event)"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-4 filter-input\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003EBonus States\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"filters.bonus_states.selected\" theme=\"select2\" title=\"Bonus State Filter\" search-enabled=\"false\" multiple close-on-select=\"false\" style=\"width:100%\"\u003E\u003Cui-select-match placeholder=\"Select Bonus State...\"\u003E{{$item.name}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"bonus_state in filters.bonus_states.options | orderBy: 'display'\"\u003E\u003Cspan ng-bind=\"bonus_state.display\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003EUser-Status\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"filters.made_status.selected\" theme=\"select2\" title=\"Made Status Filter\" search-enabled=\"false\" multiple close-on-select=\"false\" style=\"width:100%\"\u003E\u003Cui-select-match placeholder=\"Select Made Status\" allow-clear=\"true\"\u003E{{$item.name}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"status in filters.made_status.options track by $index\"\u003E\u003Cspan ng-bind=\"status.name\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003ELetzter Login\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"filters.last_login.selected\" theme=\"select2\" title=\"Last Login Filter\" search-enabled=\"false\" multiple close-on-select=\"false\" style=\"width:100%\"\u003E\u003Cui-select-match placeholder=\"Select Last Login\"\u003E{{$item.display}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"option in filters.last_login.options\"\u003E\u003Cspan ng-bind=\"option.display\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E\u003Cdatepicker date-format=\"dd.MM.yyyy\" selector=\"entrydateInput\" date-refocus=\"false\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "filters.bonus_begin","title": "Bonus Begin","attributes": {"vn-date-helper":true,"ng-pattern":"\u002F^(0?[1-9]|[12][0-9]|3[01])\\.([0]?[0-9]|1[0-2])\\.\\d{4}$\u002F"},"fieldHtmlClass": "entrydateInput"}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003ESortieren:\u003Cselect class=\"simple-select\" ng-model=\"filters.order_by_name\" vn-number-to-bool\u003E\u003Coption value=\"0\"\u003EA-Z\u003C\u002Foption\u003E\u003Coption value=\"1\"\u003EZ-A\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-12 text-right\"\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"BonusAdminCtrl.filterBonusEmployees()\" data-cy=\"vn.administration.bonus.employeeFilters.buttonSearch\"\u003ESuchen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit_arbeitnmv-wrapper\"\u003E\u003Cdiv class=\"list-box\" overlay=\"BonusAdminCtrl.loading.main\"\u003E\u003Cdiv ng-repeat=\"(employee_group_id, employee_group) in BonusAdminCtrl.grouped_employees\"\u003E\u003Cdiv class=\"list-box__row\"\u003E\u003Cdiv class=\"list-box__item\"\u003E\u003Cspan class=\"list-box__itemTitle\"\u003E\u003Cspan class=\"user-name\" style=\"font-weight: bold\"\u003E{{BonusAdminCtrl.customers_by_id[employee_group_id].name }} {{BonusAdminCtrl.customers_by_id[employee_group_id].name ? ' - ' : ' '}} {{ employee_group_id}}\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"list-box__row\" ng-class=\"{'toggable-content-open': BonusAdminCtrl.employee_objects[employeeData.id].toggleContentShowable }\" ng-repeat=\"employeeData in employee_group\" toggable-content=\"BonusAdminCtrl.employee_objects[employeeData.id].toggleContentShowable\" data-cy=\"vn.administration.bonus.{{employeeData.id}}.toggleEmployeeData\"\u003E\u003Ctoggable-content-toggler ng-init=\"employee = BonusAdminCtrl.employee_objects[employeeData.id]\" ng-click=\"BonusAdminCtrl.loadEmployeeData(employeeData, employee, toggleContentShowable)\"\u003E\u003Cdiv class=\"list-box__item\"\u003E\u003Cspan class=\"list-box__itemTitle\" ng-click=\"toggableContentCtrl.togglerClicked()\"\u003E\u003Cdiv class=\"toggable-state-feedback\"\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"user-name\"\u003E{{ employeeData.id | formatNumber:'prepend'}} | {{ employeeData.lastname }}, {{ employeeData.firstname }}\u003C\u002Fspan\u003E\u003Cspan class=\"right pc-leasing-icon blocked\" ng-if=\"BonusAdminCtrl.isEmployeeBlockedForPcLeasing(employeeData.id)\"\u003E\u003Cimg ng-src=\"\u002Fassets\u002Fimg\u002Fpc_icon.png\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"last-status-change right\" ng-if=\"filters.bonus_states.selected.length === 1\" ng-class=\"{'red': (employeeData.last_status_change | timeUntilNow:'hours') &gt; 72}\"\u003E{{employeeData.last_status_change | timeUntilNow}}\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"list-box__item__content\" toggable-content-content ng-if=\"BonusAdminCtrl.employee_objects[employeeData.id].toggleContentShowable\"\u003E\u003Cdiv class=\"cockpit_toggable-content\"\u003E\u003Cdiv class=\"cockpit__form-content\"\u003E\u003Cdiv class=\"employee-contracts-list\" ng-if=\"!employeeData.has_active_bonus_projects\"\u003ENo active bonus project for employee\u003C\u002Fdiv\u003E\u003Cdiv class=\"employee-contracts-list\" ng-if=\"employeeData.has_active_bonus_projects\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"left\"\u003E\u003Ch4\u003EBonus Übersicht\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"right\"\u003E\u003Cbutton class=\"button button-primary button-small-header isOutline\" ng-click=\"BonusAdminCtrl.editEmployee( employeeData.id )\"\u003EBearbeiten\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary button-small-header isOutline\" ng-click=\"BonusAdminCtrl.goToNEO( employeeData.id )\"\u003ENEO\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary button-small-header isOutline\" ng-click=\"BonusAdminCtrl.goToPCleasing( employeeData.id )\"\u003EPC-Leasing\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary button-small-header isOutline\" ng-click=\"BonusAdminCtrl.goToNorbert( employeeData )\"\u003ENorbert\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary button-small-header isOutline\" ng-click=\"BonusAdminCtrl.become( employeeData )\"\u003ENutzer Übernehmen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-repeat=\"bonus_project in employeeData['bonus_projects_for_employee']\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cdiv class=\"bigbox\"\u003E\u003Cdiv class=\"header\" ng-click=\"BonusAdminCtrl.toggleBonusProjectShow(employeeData, employee, bonus_project)\" data-cy=\"vn.administration.bonus.{{employeeData.id}}-{{bonus_project.name}}.toggleBonusProject\"\u003E\u003Cspan\u003EBonusProject {{ bonus_project['name']}},\u003C\u002Fspan\u003E\u003Cspan\u003E{{ bonus_project.dates.bonus_project_start_date | date: 'dd.MM.yyyy'}} -\u003C\u002Fspan\u003E\u003Cspan\u003E{{ bonus_project.dates.bonus_project_end_date | date: 'dd.MM.yyyy'}}\u003C\u002Fspan\u003E\u003Cspan class=\"openable\" ng-class=\"{selected: !!bonus_project['is_visible']}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-show=\"bonus_project['is_visible']\" overlay=\"bonus_project['is_loading']\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Cspan\u003EBasisbudget:\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Cspan\u003E{{ employeeData['bonus_projects'][bonus_project._id].bonus_budget.total | currency }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-repeat=\"display in BonusAdminCtrl.DEFAULT_BONUS_BUDGET_DISPLAY\"\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Cspan\u003E{{ display.label}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Cspan\u003E{{ BonusAdminCtrl.calculateBudgetDisplay(employeeData['bonus_projects'][bonus_project._id].bonus_budget, display, BonusAdminCtrl.BONUS_PAYMENT_TYPES_BY_NAME['budget']['id'] ) | currency }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-5\"\u003E\u003Chr\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Cspan\u003ERest:\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Cspan\u003E{{ employeeData['bonus_projects'][bonus_project._id].bonus_budget.restbonus | currency }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-repeat=\"display in BonusAdminCtrl.DEFAULT_BONUS_BUDGET_DISPLAY\" ng-if=\"BonusAdminCtrl.calculateBudgetDisplay(employeeData['bonus_projects'][bonus_project._id].bonus_budget, display, BonusAdminCtrl.BONUS_PAYMENT_TYPES_BY_NAME['exchange']['id'] ) != 0\"\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Cspan\u003E{{ display.label}} (Umwandlung)\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Cspan\u003E{{ BonusAdminCtrl.calculateBudgetDisplay(employeeData['bonus_projects'][bonus_project._id].bonus_budget, display, BonusAdminCtrl.BONUS_PAYMENT_TYPES_BY_NAME['exchange']['id'] ) | currency }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\" ng-if=\"employeeData['bonus_projects'][bonus_project._id].bikeleasing_permitted\"\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Ch4\u003EBikeleasing Übersicht\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-9\"\u003E\u003Cbutton class=\"button button-primary button-small-header isOutline right\" ng-if=\"employeeData['bonus_projects'][bonus_project._id].bikeleasing_available &amp;&amp; employeeData['bonus_projects'][bonus_project._id].limits.months_left_this_year &gt; 0\" ng-click=\"BonusAdminCtrl.openBikeleasingControlProcess(employeeData.id, employeeData.customer_id, bonus_project._id)\" data-cy=\"vn.administration.bonus.{{employeeData.id}}.buttonGiveBike\"\u003EFahrrad anlegen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"employeeData['bonus_projects'][bonus_project._id].bikeleasing_permitted\"\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Cspan\u003EMax Leasingrate:\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-9\"\u003E\u003Cspan\u003E{{ employeeData['bonus_projects'][bonus_project._id].limits.max_user_rate_without_insurance | currency }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Cspan\u003EMax Gehaltsumwandlung:\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-9\"\u003E\u003Cspan\u003E{{ employeeData['bonus_projects'][bonus_project._id].limits.max_user_rate | currency }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Cspan\u003Emaximaler Leasingumfang:\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-9\"\u003E\u003Cspan\u003E{{ employeeData['bonus_projects'][bonus_project._id].limits.max_bike_value | currency }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Cspan\u003EBBG\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-9\"\u003E\u003Cspan\u003E{{ employeeData['bonus_projects'][bonus_project._id].bbg.display || '-' }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!employeeData['bonus_projects'][bonus_project._id].bikeleasing_permitted\"\u003E\u003Cp class=\"error\"\u003E\u003Cstrong\u003EDas verfügbare Budget reicht nicht für eine Nutzung aus.\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-4\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_mixins["checkbox"].call({
attributes: {"key": "BonusAdminCtrl.display_filters.to_show_declined","title": "Show Declined"}
});
},
attributes: {"name": "BonusAdminCtrl.forms.display_filters"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Ch4\u003EComponent\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1\"\u003E\u003Ch4\u003ECheckout\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1\"\u003E\u003Ch4\u003EBegin\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1\"\u003E\u003Ch4\u003EEnd\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1\"\u003E\u003Ch4\u003EAmount\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Ch4\u003EStatus\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-repeat=\"bonus in BonusAdminCtrl.getUnavailableBonuses(employeeData['bonus_projects'][bonus_project._id])\"\u003E\u003Cdiv class=\"columns medium-2 contract-data\" data-cy=\"vn.administration.bonus.{{employeeData.id}}-{{bonus_project.name}}-{{bonus._id}}.textBonusTitle\"\u003E\u003Cspan\u003E{{ BonusAdminCtrl.BONUS_COMPONENTS_BY_NAME[BonusAdminCtrl.BonusService.getBonusComponentName(bonus)].display.title }}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"BonusAdminCtrl.BonusService.isBBGRelevantForComponent(BonusAdminCtrl.BonusService.getBonusComponentName(bonus))\"\u003E {{' | ' + BonusAdminCtrl.BONUS_PAYMENT_TYPES_BY_ID[bonus.checkout_config.bonus_payment_type]['short_display'] || '-' }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1 contract-data\"\u003E{{ (BonusAdminCtrl.getComponentDisplayCheckoutDate(bonus).checkout_date | date:'dd.MM.yy')}} {{ BonusAdminCtrl.getComponentDisplayCheckoutDate(bonus).custom_checkout_date ? ('(' + (BonusAdminCtrl.getComponentDisplayCheckoutDate(bonus).custom_checkout_date | date:'dd.MM.yy') + ')') : ''   }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1 contract-data\" data-cy=\"vn.administration.bonus.{{employeeData.id}}-{{bonus_project.name}}-{{bonus._id}}.textBonusBeginDate\"\u003E{{ BonusAdminCtrl.getComponentDisplayStartDate(bonus) | date:'dd.MM.yy' }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1 contract-data\" data-cy=\"vn.administration.bonus.{{employeeData.id}}-{{bonus_project.name}}-{{bonus._id}}.textBonusEndDate\"\u003E{{ BonusAdminCtrl.getComponentDisplayEndDate(bonus)  | date:'dd.MM.yy' }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1 contract-data\"\u003E{{ bonus.bonus_value | currency }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data padding-right\" data-cy=\"vn.administration.bonus.{{employeeData.id}}-{{bonus_project.name}}-{{bonus._id}}.textBonusState\"\u003E\u003Ca ng-click=\"BonusAdminCtrl.openBonusHistoryDialog(bonus)\"\u003E{{BonusAdminCtrl.BONUS_STATES_BY_ID[bonus.state].display}}\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-4\"\u003E\u003Cbutton class=\"button button-primary button-small-header isOutline\" ng-click=\"BonusAdminCtrl.startControlProcess(employeeData.id, employeeData.customer_id, bonus._id, employeeData, employee)\" ng-if=\"BonusAdminCtrl.showControlProcessButton(bonus)\" data-cy=\"vn.administration.bonus.{{employeeData.id}}-{{bonus_project.name}}-{{bonus._id}}.buttonBonusContractProcess\"\u003EKontrolle\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary button-small-header isOutline right\" ng-if=\"BonusAdminCtrl.showBikeleasingApprovalButton(bonus)\" ng-click=\"BonusAdminCtrl.openBikeleasingApproveDialog(employeeData.id, bonus_project._id, employeeData, bonus)\" data-cy=\"vn.administration.bonus.{{employeeData.id}}-{{bonus_project.name}}-{{bonus._id}}.buttonConfirmBonus\"\u003EFreigabe\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary button-small-header isOutline right\" ng-if=\"BonusAdminCtrl.canEditBonus(bonus)\" ng-click=\"BonusAdminCtrl.openEditBonus(employeeData.id, bonus, bonus_project._id, employeeData, employee)\" data-cy=\"vn.administration.bonus.{{employeeData.id}}-{{bonus_project.name}}-{{bonus._id}}.buttonEditBonus\"\u003EAblehnen \u002F Editieren\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary button-small-header isOutline right\" ng-if=\"BonusAdminCtrl.canCancelBonus(bonus)\" ng-click=\"BonusAdminCtrl.openCancelBonus(employeeData.id, bonus, bonus_project._id, employeeData, employee)\" data-cy=\"vn.administration.bonus.{{employeeData.id}}-{{bonus_project.name}}-{{bonus._id}}.buttonPreendBonus\"\u003EVorzeitiges Ende\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Ch4\u003EDokumentenliste\u003C\u002Fh4\u003E\u003Cbr\u003E\u003Cdocument-list-component ng-if=\"!BonusAdminCtrl.loading.main &amp;&amp; bonus_project['is_visible'] &amp;&amp; !bonus_project['is_loading']\" options=\"{for_latest_contract_only: false, valuenet_id: employeeData.id, show_neo_documents: false, to_notify_advisor_on_upload: false, bonus_project_id: bonus_project._id, allowed_components:employeeData['bonus_projects'][bonus_project._id].bonuses, show_audit_trail: true}\"\u003E\u003C\u002Fdocument-list-component\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftoggable-content-toggler\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;